import { Component, OnInit } from '@angular/core';
import { RentalsService } from '../../../../../services/rentals.service';
import { HelpersService } from '../../../../../services/helpers.service';
import moment from 'moment';
import { MessageService } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-rentals-time-configuration',
  templateUrl: './rentals-time-configuration.component.html',
  styleUrls: ['./rentals-time-configuration.component.scss'],
})
export class RentalsTimeConfigurationComponent implements OnInit {
  public partner: any = {};
  public configuaration: any = {};
  public busy: boolean = false;
  public updatingDefaultStoreTimes: boolean = false;

  constructor(
    private rentalsService: RentalsService,
    private helpersService: HelpersService,
    private messageService: MessageService,
    private translate: TranslateService,
  ) {}

  ngOnInit() {
    this.partner = this.helpersService.getPartnerData();
    this.getConfiguration();
  }

  getConfiguration() {
    this.rentalsService
      .getRentalConfiguration(this.helpersService.getPartnerId())
      .subscribe((configuaration) => {
        this.configuaration = configuaration;
        this.configuaration.defaultStoreTimes.forEach((x) => {
          if (x.startTime != null && x.startTime.length === 8) {
            x.startTime = moment('1970-01-01T' + x.startTime).toDate();
          }
          if (x.endTime != null && x.endTime.length === 8) {
            x.endTime = moment('1970-01-01T' + x.endTime).toDate();
          }
        });
      });
  }

  getDayLabel(dayOfWeek) {
    switch (dayOfWeek) {
      case 1:
        return 'general.monday';
        break;
      case 2:
        return 'general.tuesday';
        break;
      case 3:
        return 'general.wednesday';
        break;
      case 4:
        return 'general.thursday';
        break;
      case 5:
        return 'general.friday';
        break;
      case 6:
        return 'general.saturday';
        break;
      case 0:
        return 'general.sunday';
        break;
    }
  }

  formatTime(value) {
    return value === null || value === undefined
      ? '00:00'
      : moment((value.length === 8 ? '1970-01-01T' : '') + value).format(
          'HH:mm',
        );
  }

  updateDefaultStoreHours() {
    this.updatingDefaultStoreTimes = true;
    var data = {
      ID: this.configuaration.id,
      DefaultPartnerID: this.configuaration.defaultPartnerID,
      DefaultStoreTimes: this.configuaration.defaultStoreTimes.map((x) => {
        return {
          ...x,
          startTime: moment(x.startTime).format('HH:mm:ss'),
          endTime: moment(x.endTime).format('HH:mm:ss'),
        };
      }),
    };
    this.rentalsService.updateRentalConfigDefaultStoreTimes(data).subscribe(
      (config) => {
        console.log(config);
        config.defaultStoreTimes.forEach((x) => {
          if (x.startTime != null && x.startTime.length === 8) {
            x.startTime = moment('1970-01-01T' + x.startTime).toDate();
          }
          if (x.endTime != null && x.endTime.length === 8) {
            x.endTime = moment('1970-01-01T' + x.endTime).toDate();
          }
        });
        this.configuaration.defaultStoreTimes = config.defaultStoreTimes;
        this.updatingDefaultStoreTimes = false;
        this.messageService.add({
          life: 5000,
          detail: this.translate.instant(
            'bikeshop.rentals.configuration.updated_configuration_default_hours',
          ),
          closable: false,
        });
      },
      (err) => {
        this.updatingDefaultStoreTimes = false;
      },
    );
  }
}
